"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaTypeEnum = void 0;
/**
 * media-type.enum
 */
var MediaTypeEnum;
(function (MediaTypeEnum) {
    // Global
    MediaTypeEnum["APPLICATION_JSON"] = "application/json";
    MediaTypeEnum["APPLICATION_XML"] = "application/xml";
})(MediaTypeEnum || (exports.MediaTypeEnum = MediaTypeEnum = {}));
